import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { HTMLAttributes, useState } from 'react';

import {
  TransactionParamActionType,
} from '../hooks/usePrepaidCardTransactions';

interface Props extends HTMLAttributes<HTMLDivElement>{
    period: Exclude<TransactionParamActionType, 'nextPage'>;
    setPeriod: (period: Exclude<TransactionParamActionType, 'nextPage'>) => void;
}

function Period(props: Props) {
  const { period, setPeriod, ...rest } = props;
  return (
      <TabList variant='solid' {...rest}>
          <TabItem selected={period === 'week'} onClick={() => setPeriod('week')}>
              1주일
          </TabItem>
          <TabItem selected={period === 'month'} onClick={() => setPeriod('month')}>1개원</TabItem>
          <TabItem selected={period === 'quarter'} onClick={() => setPeriod('quarter')}>3개원</TabItem>
          <TabItem selected={period === 'all'} onClick={() => setPeriod('all')}>전체</TabItem>
      </TabList>
  );
}

export default Period;
